import { isObject } from './helpers';
import { GLOBAL_CONSTANTS } from './constants';

function getCategory(categoryId) {
  const category = GLOBAL_CONSTANTS.categories.find(
    category => category.id === categoryId,
  );
  return category ? category.title : null;
}

function getUnderscoreLabel(ad) {
  if (!ad?.labels?.length) {
    return null;
  }

  return ad.labels
    .map(label => (isObject(label) ? label.slug : label).replace(/-/g, '_'))
    .join(', ');
}

export function convertToDataLayerSelectedAd({
  ad,
  listId,
  index,
  listName,
  transaction_id,
}) {
  return [
    {
      item_name: ad.title,
      item_id: ad._meta?.reference_id || ad.reference_id,
      item_category: getCategory(ad.category_id),
      item_category2: getUnderscoreLabel(ad),
      item_category3: ad.location?.settlement || ad.city,
      age: ad.age || null,
      gender: ad.gender || null,
      item_list_id: listId,
      item_list_name: listName,
      ...(ad.category_id === 1 && { date: ad.start_date }),
      ...(transaction_id && { transaction_id }),
      ...(ad.transaction_id && { transaction_id: ad.transaction_id }),
      ...(ad.category_id === 2 &&
        ad.company_type && { item_variant: ad.company_type }),
      ...(index && {
        index: index + 1,
      }),
    },
  ];
}

export function convertToDataLayerAds({ ads, listId, listName }) {
  return ads.map((ad, index) => ({
    item_name: ad.title,
    item_id: ad.reference_id,
    item_category: getCategory(ad.category_id),
    item_category2: ad.labels[0] || null,
    item_category3: ad.city,
    age: ad.age || null,
    item_list_name: '',
    gender: ad.gender || null,
    index: index + 1,
    ...(ad.category_id === 1 && { date: ad.start_date }),
    ...(ad.category_id === 2 &&
      ad.company_type && { item_variant: ad.company_type }),
    item_list_id: listId || '',
    ...(listName && { item_list_name: listName }),
  }));
}

export const getProductAnalyticsData = (
  { product_name, product_id, period_count, period_unit, price, coupon },
  index,
) => {
  const isCredit = product_name.includes('credits');

  return {
    item_name: isCredit
      ? `Update balance - ${price.final_price}€`
      : product_name,
    item_id: isCredit ? `Update balance - ${price.final_price}€` : product_id,
    item_category: isCredit ? 'Update balance' : 'promos',
    item_list_name: product_name,
    index,
    item_variant: isCredit ? price.final_price : period_unit,
    price: price.final_price,
    quantity: isCredit ? 1 : period_count,
    discount: price.account_discount,
    coupon: coupon || '',
    ...(!isCredit && { currency: 'EUR' }),
  };
};

export const getProductsAnalyticsData = products =>
  products.map((product, index) => {
    return getProductAnalyticsData(product, index);
  });
